import { action, autorun, computed, observable, observe, reaction } from 'mobx';
import { Store } from './mainStore';

const SCAN_MODES = ['non-weighted', 'weighted', 'semi-weighted', 'foambox'] as const;
export type ScanModes = typeof SCAN_MODES[number];

export default class AgentStore {
	store: Store;
	@observable scannedInThisSession = false;
	@observable oneFootScan = false;
	@observable scanMode: ScanModes = 'semi-weighted';

	@observable downloadingUpdate = false;
	@observable requiredUpdate = true;
	@observable updateAvailable = false;
	@observable currentDevice: { name: string; id: number; model: string; model_id: string; type: string; serial: string } = {
		id: 0,
		model: '',
		model_id: '',
		serial: '',
		type: '',
		name: ''
	};

	public async setCurrentDevice(device) {
		const a = await this.store.engine.agent;
		this.currentDevice = { ...device };
		await a.setCurrentDevice(device);
	}

	constructor(mainStore: Store) {
		this.store = mainStore;
	}

	public setScanSettings(scanMode: string) {
		scanMode = scanMode
			.toLowerCase()
			.split('_')
			.join('-');
		const mode = scanMode as ScanModes;
		if (SCAN_MODES.includes(mode)) {
			console.log('Set scan mode: ', mode);
			this.store.agent.scanMode = mode;
			this.scanMode = mode;
		} else {
			console.log('Invalid scan mode, not included: ', mode);
		}
	}

	@action
	async setAgentUri(agentUri: string) {
		console.log(`setting agent uri to ${agentUri}`);

		if (agentUri.includes('://')) {
			agentUri = agentUri.split('://')[1];
		}

		let addr = agentUri.split(':')[0];
		let port = +agentUri.split(':')[1].replace('/', '');

		console.log(addr, port);

		if (!port) {
			console.error('agent – no port set');
			port = 80;
		}

		let agent = await this.store.engine.agent;
		agent.setAddress(addr, port);
	}
}
